export default "__VITE_ASSET__DCYws3Kq__"